module.exports = __webpack_public_path__ + "images/icon/btn_xbrl-4d4a5406.svg";